document.addEventListener('page:loaded', function() {
  $(document).ready(function($) {
    $('.dynamic-camparsionslider').owlCarousel({
      loop:true,
      margin:0,
      nav:false,
      responsive:{
          0:{
              items:1
          },
          600:{
              items:1
          },
          1000:{
              items:1
          }
       }
     });
    
  });
  
});

document.addEventListener('page:loaded', function() {
  $(document).ready(function($) {
    $('.product-list-slider').owlCarousel({
      // loop:true,
      margin:30,
      nav:false,
      dots: false,
      responsive:{
          0:{
            items:1,
            margin:0,
            autoplay:true,
            autoplayTimeout:3000,
            autoplayHoverPause:true

          },
          600:{
            items:2,
            margin:30
          },
          1000:{
            items:3
          }
       }
     });
    
  });
  
});

$(document).ready(function () {
  var $variantDropdown = $("[name='id']");
  function showVideoForVariant(variantId) {
    $(".video-box-3").hide();

    $(".video-box-3[data-variant='" + variantId + "']").show();
  }

  if ($variantDropdown.length) {
    showVideoForVariant($variantDropdown.val());

    $variantDropdown.on("change", function () {
      showVideoForVariant($(this).val());
    });
  }
});

document.addEventListener('page:loaded', function() {
  $(document).ready(function($) {
    $('.dynamic-camparsionslider-3-in-1').owlCarousel({
      loop:true,
      margin:0,
      nav:false,
      responsive:{
          0:{
              items:1
          },
          600:{
              items:1
          },
          1000:{
              items:1
          }
       }
     });
    
  });
  
})

// What include in the box

document.addEventListener("DOMContentLoaded", function () {
    var singleKitId = "51678786421046";
    var doubleKitId = "51678786453814";
    var tripleKitId = "51678786486582";

    function updateTextDisplay(variantId) {
        document.querySelectorAll("li").forEach((li) => {
            var singleKitText = li.querySelector(".single-kit");
            var doubleKitText = li.querySelector(".double-kit");
            var tripleKitText = li.querySelector(".triple-kit");

            if (singleKitText && doubleKitText && tripleKitText) {
                if (variantId == singleKitId) {
                    singleKitText.style.display = "block";
                    doubleKitText.style.display = "none";
                    tripleKitText.style.display = "none";
                } else if (variantId == doubleKitId) {
                    singleKitText.style.display = "none";
                    doubleKitText.style.display = "block";
                    tripleKitText.style.display = "none";
                } else if (variantId == tripleKitId) {
                    singleKitText.style.display = "none";
                    doubleKitText.style.display = "none";
                    tripleKitText.style.display = "block";
                }
            }
        });
    }

    var variantSelector = document.querySelector('[name="id"]');

    if (variantSelector) {
        updateTextDisplay(variantSelector.value);

        variantSelector.addEventListener("change", function () {
            updateTextDisplay(this.value);
        });
    }
});

document.addEventListener("DOMContentLoaded", function () {
    var singleKitId = "51678786421046";
    var doubleKitId = "51678786453814";
    var tripleKitId = "51678786486582";

    var variantSelect = document.querySelector("[name='id']"); 

    function updateVisibility(selectedVariantId) {
        document.querySelectorAll(".specs__sidebar .gap-2d5").forEach(div => {
            div.style.display = "none";
        });

        if (selectedVariantId === tripleKitId) {
            document.querySelectorAll(".gap-2d5.list-item-1").forEach(div => div.style.display = "block");
        } else if (selectedVariantId === doubleKitId) {
            document.querySelectorAll(".gap-2d5.list-item-1, .gap-2d5.list-item-2, .gap-2d5.list-item-4, .gap-2d5.list-item-5, .gap-2d5.list-item-6, .gap-2d5.list-item-7, .gap-2d5.list-item-8, .gap-2d5.list-item-9").forEach(div => div.style.display = "block");
        } else if (selectedVariantId === singleKitId) {
            document.querySelectorAll(".specs__sidebar .gap-2d5.grid").forEach(div => div.style.display = "block");
        }
    }

    if (variantSelect) {
        updateVisibility(variantSelect.value);

        variantSelect.addEventListener("change", function () {
            updateVisibility(this.value);
        });
    }
});


// Countdown Timer
document.addEventListener("DOMContentLoaded", function () {
    function startCountdown(timerElement) {
        let endTimeStr = timerElement.getAttribute("data-end-time");
        let timeZone = timerElement.getAttribute("data-timezone") || "America/New_York";
        let endTime = new Date(endTimeStr);

        function updateCountdown() {
            let currentTime = new Date();
            let options = { timeZone: timeZone };
            let localTime = new Date(currentTime.toLocaleString("en-US", options));

            let timeRemaining = endTime - localTime;

            if (timeRemaining <= 0) {
                timerElement.innerHTML = "Time Expired";
                return;
            }

            let days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
            let hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            let minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
            let seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

            timerElement.innerHTML = `Ends in: ${days}d ${hours}h ${minutes}m ${seconds}s`;
        }

        updateCountdown();
        setInterval(updateCountdown, 1000);
    }
    document.querySelectorAll(".countdown-timer").forEach(startCountdown);
});

if (jQuery(window).width() <= 768) {
  jQuery(".product-countdown").appendTo(".featured-product");
}

// Sale Badge
document.addEventListener("DOMContentLoaded", function () {
    function updateDiscountBadge(variant) {
        if (!variant) return;

        let compareAtPrice = variant.compare_at_price;
        let price = variant.price;

        if (compareAtPrice && compareAtPrice > price) {
            let discount = Math.round(((compareAtPrice - price) * 100) / compareAtPrice);
            document.getElementById("discount-value").textContent = discount;
            document.getElementById("discount-badge").style.display = "block";
        } else {
            document.getElementById("discount-badge").style.display = "none";
        }
    }

    function getSelectedVariant() {
        let variantId = document.querySelector("[name='id']")?.value;
        let productData = window.product || window.Shopify?.product;
        return productData?.variants?.find(v => v.id == variantId);
    } 

    setTimeout(() => {
        updateDiscountBadge(getSelectedVariant());
    }, 500);

    document.querySelector("[name='id']")?.addEventListener("change", function () {
        updateDiscountBadge(getSelectedVariant());
    });
});

// Percent Off Badge
document.addEventListener("DOMContentLoaded", function () {

    function updateDiscountBadge(variant) {
        if (!variant) return;

        let compareAtPrice = variant.compare_at_price;
        let price = variant.price;

        const badge = document.querySelector(".discount-badge-amount");
        const valueSpan = document.getElementById("discount-value-amount");

        if (badge && valueSpan && compareAtPrice && compareAtPrice > price) {
            let discount = Math.round(((compareAtPrice - price) * 100) / compareAtPrice);

            valueSpan.textContent = `${discount}% OFF`;
            badge.style.display = "block";
        } else if (badge) {
            badge.style.display = "none";
        }
    }

    function getSelectedVariant() {
        let variantId = document.querySelector("[name='id']")?.value;
        let productData = window.product || window.Shopify?.product;

        return productData?.variants?.find(v => v.id == variantId);
    }

    setTimeout(() => {
        updateDiscountBadge(getSelectedVariant());
    }, 300);

    document.querySelector("[name='id']")?.addEventListener("change", function () {
        updateDiscountBadge(getSelectedVariant());
    });

    document.addEventListener("variant:change", function (event) {
        updateDiscountBadge(event.detail.variant);
    });

});





// Variants Description
document.addEventListener("DOMContentLoaded", function () {
    var descriptionConfigs = [
        {
            elementId: "variant-description",
            variantDescriptions: {
                "51891814007094" :"Free Community Access",
                "51819741348150": "All the essentials for upper‑ and lower‑body cable exercises in a compact package—no extra bells and whistles. Perfect for users with limited space who want a flexible, no‑fuss pulley setup.",
                "51678786421046": "Replaces 10 separate cable machines with a single, versatile cable kit. Home gym owners who want an all-in-one solution.",
                "51678786453814": "Combines the power of 3 different cable machines in one sleek setup. Home gym owners seeking space savings."
              }
        },
        {
            elementId: "variant-description-new",
            variantDescriptions: {
                "51781885755702": "All the essentials for upper‑ and lower‑body cable exercises in a compact package—no extra bells and whistles. Perfect for users with limited space who want a flexible, no‑fuss pulley setup.",
                "51781885722934": "The included Anchor Pad adds extra stability for low rows, glute work, or any movement where a solid base is key. Ideal for home gyms seeking maximum versatility without bulky machines.",
            }
        },
        {
            elementId: "variant-description-high-pulley",
            variantDescriptions: {
                "52470829220150": "The Single High  Pulley Kit includes all the essentials for smooth, effective workouts, featuring a high-quality pulley, a durable loading pin, coated cables, and a mounting strap. It’s everything you need to set up upper-body cable exercises in any space, without the bulk..",
                "52470920708406": "The Double High Pulley Kit is built for dynamic, full-range cable training featuring two high-quality pulleys, a sturdy loading pin, coated cables, carabiners, mounting straps, and added weight straps for secure loading. Ideal for push-pull movements and smoother resistance transitions in any setup.",
            }
        },
        {
            elementId: "black-variant-description-high-pulley",
            variantDescriptions: {
                "53272680988982": "The Single High  Pulley Kit includes all the essentials for smooth, effective workouts, featuring a high-quality pulley, a durable loading pin, coated cables, and a mounting strap. It’s everything you need to set up upper-body cable exercises in any space, without the bulk..",
                "53272681021750": "The Double High Pulley Kit is built for dynamic, full-range cable training featuring two high-quality pulleys, a sturdy loading pin, coated cables, carabiners, mounting straps, and added weight straps for secure loading. Ideal for push-pull movements and smoother resistance transitions in any setup.",
            }
        }
    ];

    descriptionConfigs.forEach(function (config) { 
        var descriptionElement = document.getElementById(config.elementId);
        if (!descriptionElement) return;

        function updateDescription(variantId) {
            if (config.variantDescriptions[variantId]) {
                descriptionElement.innerHTML = config.variantDescriptions[variantId];
            } else {
                descriptionElement.innerHTML = "";
            }
        }

        var initialVariant = document.querySelector("[name='id']:checked, [name='id'] option[selected]");
        if (initialVariant) {
            updateDescription(initialVariant.value);
        } else {
            var firstVariantId = Object.keys(config.variantDescriptions)[0];
            updateDescription(firstVariantId);
        }

        document.querySelectorAll("[name='id']").forEach(function (variantSelector) {
            variantSelector.addEventListener("change", function () {
                updateDescription(this.value);
            });
        });
    });
});


window.addEventListener("load", function() {
    var iframe = document.querySelector("iframe#chat-button");
    if (iframe) {
        var css = `
            #gorgias-chat-messenger-button{
                height: 44px !important;
                max-width: 44px !important;
                padding: 0px !important;
                margin: 0 !important;
                border: none !important;
                display: flex;
                align-items: center;
                justify-content: center;
              }

              #gorgias-chat-messenger-button:hover{
                transform: none !important;
              }
              
              .messenger-button-iframe-131bpt9 {
                left: auto !important;
                width: 15px !important;
                height: 15px !important;
                right: auto !important;
                text-align: center;
            }

            .messenger-button-iframe-11uj9w1,
            .messenger-button-iframe-qnqyme{
               width: fit-content !important;
            }

            svg{
              height: 20px !important;
              width: 20px !important;
            }

            .messenger-button-iframe-7nwc9h{
              width: fit-content !important;
              left: 27% !important;
              top: 4px !important;
            }
        `;
        var styleTag = iframe.contentDocument.createElement("style");
        styleTag.innerHTML = css;
        iframe.contentDocument.head.appendChild(styleTag);
    }
});

// document.addEventListener("DOMContentLoaded", function () {
//   const targetVariantId = "51891814007094";
//   const valueStatementElement = document.querySelector(".value-statment.bullet-pulley p");

//   if (!valueStatementElement) return;

//   valueStatementElement.style.display = "none";

//   function handleVariantChange(selectedVariantId) {
//     if (selectedVariantId === targetVariantId) {
//       valueStatementElement.style.display = "block";
//     } else {
//       valueStatementElement.style.display = "none";
//     }
//   }

//   const urlParams = new URLSearchParams(window.location.search);
//   const variantIdFromUrl = urlParams.get("variant");

//   if (variantIdFromUrl) {
//     handleVariantChange(variantIdFromUrl);
//   } else {
//     const currentVariantInput =
//       document.querySelector("[name='id']:checked") ||
//       document.querySelector("[name='id']");

//     if (currentVariantInput) {
//       handleVariantChange(currentVariantInput.value);
//     }
//   }

//   document.querySelectorAll("[name='id']").forEach((input) => {
//     input.addEventListener("change", function () {
//       handleVariantChange(this.value);
//     });
//   });
// });

document.addEventListener("DOMContentLoaded", function () {
  const variantMessages = {
    "53219472965942": "Includes 8 bands for $78",
    "53219472933174": "Includes 4 bands for $39",
  };

  const messageElement = document.querySelector(".bands-message");
  if (!messageElement) return;

  messageElement.style.display = "none";

  function updateBandsMessage(selectedVariantId) {
    if (variantMessages[selectedVariantId]) {
      messageElement.textContent = variantMessages[selectedVariantId];
      messageElement.style.display = "block";
    } else {
      messageElement.style.display = "none";
    }
  }

  const urlParams = new URLSearchParams(window.location.search);
  const variantIdFromUrl = urlParams.get("variant");

  if (variantIdFromUrl) {
    updateBandsMessage(variantIdFromUrl);
  } else {
    const currentVariantInput =
      document.querySelector("[name='id']:checked") ||
      document.querySelector("[name='id']");

    if (currentVariantInput) {
      updateBandsMessage(currentVariantInput.value);
    }
  }

  document.querySelectorAll("[name='id']").forEach((input) => {
    input.addEventListener("change", function () {
      updateBandsMessage(this.value);
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  var variantTagline = document.getElementById("variant-product-tagline");
  var variantDataElement = document.getElementById("variant-product-tagline-data");
  if (!variantTagline || !variantDataElement) return;
  var variantTaglineData = JSON.parse(
    variantDataElement.getAttribute("data-variants") || "{}"
  );

  function updateVariantTagline(variantId) {
    if (!variantId) return;
    var tagline = variantTaglineData[String(variantId)] || "";
    variantTagline.textContent = tagline;
  }

  function getCurrentVariantId() {
    var variantInput = document.querySelector("[name='id']");
    return variantInput ? variantInput.value : null;
  }
  updateVariantTagline(getCurrentVariantId());
  document.querySelectorAll("[name='id']").forEach(function (variantSelector) {
    variantSelector.addEventListener("change", function () {
      updateVariantTagline(this.value);
    });
  });
  document.addEventListener("variant:change", function (event) {
    if (event.detail && event.detail.variant) {
      updateVariantTagline(event.detail.variant.id);
    }
  });
});



// 1) Listen for any "add to cart" on the page
// document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
//   form.addEventListener('submit', async function(e) { 
//     e.preventDefault();
//     const formData = new FormData(form);
//     const productId = formData.get('id');
//     if (productId === '51868798910774') {
//       try {
//         await fetch('/cart/add.js', {
//           method: 'POST',
//           body: formData
//         }).then(res => res.json());

//         await fetch('/cart/add.js', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({
//             items: [{
//               id: '51868798910774', 
//               quantity: 1
//             }]
//           })
//         }).then(res => res.json());

//         const cart = await fetch('/cart.js').then(res => res.json());
//         document.dispatchEvent(new CustomEvent('cart:updated', {
//           detail: cart
//         }));
//         document.dispatchEvent(new CustomEvent('cart:refresh', {
//           bubbles: true,
//           detail: {
//             cart,      
//             open: true 
//           }
//         }));
//       } catch (err) {
//         console.error('Cart update failed:', err);
//       }
//     }
//   });
// });
 


// Triple Offer
// const TRIGGER_GROUP = [
//   51891814007094,
//   51678786453814,
//   51819741348150
// ];

// const FREE_GROUP_PRODUCT = 51340244025654; 
// const SPECIAL_TRIGGER = 51891814007094;       
// const SPECIAL_FREE_PRODUCT = 53219500622134;   
// const THIRD_FREE_PRODUCT = 51265098481974;    

// let cartWatcherRunning = false;

// function disableFreeProductPointer() {
//   const qtyComponents = document.querySelectorAll('quantity-input');

//   qtyComponents.forEach(component => {
//     const input = component.querySelector('input.quantity__input');
//     if (!input) return;

//     const variantId = input.dataset.quantityVariantId 
//       ? parseInt(input.dataset.quantityVariantId) 
//       : null;

//     if (
//       variantId === FREE_GROUP_PRODUCT ||
//       variantId === SPECIAL_FREE_PRODUCT ||
//       variantId === THIRD_FREE_PRODUCT
//     ) {
//       input.disabled = true;
//       input.style.pointerEvents = 'none';
//       input.style.opacity = '0.5';

//       const buttons = component.querySelectorAll('button.quantity__button');
//       buttons.forEach(btn => {
//         btn.disabled = true;
//         btn.style.pointerEvents = 'none';
//         btn.style.opacity = '0.5';
//       });
//     }
//   });
// }

// async function ensureFreeProduct() {
//   if (cartWatcherRunning) return;
//   cartWatcherRunning = true;

//   try {
//     const cart = await fetch('/cart.js').then(r => r.json());

//     const hasGroupTrigger = cart.items.some(item =>
//       TRIGGER_GROUP.includes(item.variant_id)
//     );

//     const hasSpecialTrigger = cart.items.some(
//       item => item.variant_id === SPECIAL_TRIGGER
//     );

//     const groupFreeItem = cart.items.find(
//       item => item.variant_id === FREE_GROUP_PRODUCT
//     );

//     const specialFreeItem = cart.items.find(
//       item => item.variant_id === SPECIAL_FREE_PRODUCT
//     );

//     const thirdFreeItem = cart.items.find(
//       item => item.variant_id === THIRD_FREE_PRODUCT
//     );

//     let updated = false;
//     if (hasGroupTrigger && !groupFreeItem) {
//       await fetch('/cart/add.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           items: [{ id: FREE_GROUP_PRODUCT, quantity: 1 }]
//         })
//       });
//       updated = true;
//     }

//     if (groupFreeItem && groupFreeItem.quantity > 1) {
//       await fetch('/cart/change.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           id: groupFreeItem.key,
//           quantity: 1
//         })
//       });
//       updated = true;
//     }
    
//     if (hasSpecialTrigger) {

//       if (!specialFreeItem) {
//         await fetch('/cart/add.js', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({
//             items: [{ id: SPECIAL_FREE_PRODUCT, quantity: 1 }]
//           })
//         });
//         updated = true;
//       }

//       if (!thirdFreeItem) {
//         await fetch('/cart/add.js', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({
//             items: [{ id: THIRD_FREE_PRODUCT, quantity: 1 }]
//           })
//         });
//         updated = true;
//       }
//     }

//     if (specialFreeItem && specialFreeItem.quantity > 1) {
//       await fetch('/cart/change.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           id: specialFreeItem.key,
//           quantity: 1
//         })
//       });
//       updated = true;
//     }

//     if (thirdFreeItem && thirdFreeItem.quantity > 1) {
//       await fetch('/cart/change.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           id: thirdFreeItem.key,
//           quantity: 1
//         })
//       });
//       updated = true;
//     }

//     if (updated) {
//       const updatedCart = await fetch('/cart.js').then(r => r.json());

//       document.dispatchEvent(new CustomEvent('cart:updated', {
//         detail: updatedCart
//       }));

//       document.dispatchEvent(new CustomEvent('cart:refresh', {
//         bubbles: true,
//         detail: {
//           cart: updatedCart,
//           open: true
//         }
//       }));

//       disableFreeProductPointer();
//     }

//   } catch (e) {
//     console.error('Cart watcher error:', e);
//   } finally {
//     cartWatcherRunning = false;
//   }
// }

// document.addEventListener('DOMContentLoaded', () => {
//   ensureFreeProduct();
//   disableFreeProductPointer();
// });

// document.addEventListener('change', e => {
//   if (e.target.matches('input[name="updates[]"], input.cart-quantity')) {
//     ensureFreeProduct();
//     disableFreeProductPointer();
//   }
// });

// document.addEventListener('cart:updated', ensureFreeProduct);
// document.addEventListener('cart:refresh', ensureFreeProduct);

// const cartContainer = document.querySelector('cart-drawer, .cart__wrapper, .cart-items');
// if (cartContainer) {
//   const observer = new MutationObserver(() => {
//     disableFreeProductPointer();
//   });
//   observer.observe(cartContainer, { childList: true, subtree: true });
// }


//Double Offer
// const TRIGGER_VARIANTS = [
//   51891814007094,
//   51678786453814
// ];

// const FREE_PRODUCTS = [
//   51340244025654,
//   51265098481974
// ];

// let cartWatcherRunning = false;

// function disableFreeProductPointer() {
//   const qtyComponents = document.querySelectorAll('quantity-input');

//   qtyComponents.forEach(component => {
//     const input = component.querySelector('input.quantity__input');

//     if (!input) return;

//     const variantId = input.dataset.quantityVariantId
//       ? parseInt(input.dataset.quantityVariantId)
//       : null;

//     if (FREE_PRODUCTS.includes(variantId)) {
//       input.disabled = true;
//       input.style.pointerEvents = 'none';
//       input.style.opacity = '0.5';

//       const buttons = component.querySelectorAll(
//         'button.quantity__button'
//       );

//       buttons.forEach(button => {
//         button.disabled = true;
//         button.style.pointerEvents = 'none';
//         button.style.opacity = '0.5';
//       });
//     }
//   });
// }

// async function ensureFreeProducts() {
//   if (cartWatcherRunning) return;

//   cartWatcherRunning = true;

//   try {
//     const cart = await fetch('/cart.js').then(response => response.json());
//     const hasTriggerVariant = cart.items.some(item =>
//       TRIGGER_VARIANTS.includes(item.variant_id)
//     );

//     const freeProduct1 = cart.items.find(
//       item => item.variant_id === FREE_PRODUCTS[0]
//     );

//     const freeProduct2 = cart.items.find(
//       item => item.variant_id === FREE_PRODUCTS[1]
//     );

//     let updated = false;
//     if (hasTriggerVariant) {
//       const itemsToAdd = [];

//       if (!freeProduct1) {
//         itemsToAdd.push({
//           id: FREE_PRODUCTS[0],
//           quantity: 1
//         });
//       }

//       if (!freeProduct2) {
//         itemsToAdd.push({
//           id: FREE_PRODUCTS[1],
//           quantity: 1
//         });
//       }

//       if (itemsToAdd.length > 0) {
//         await fetch('/cart/add.js', {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json'
//           },
//           body: JSON.stringify({
//             items: itemsToAdd
//           })
//         });

//         updated = true;
//       }
//     }
//     if (!hasTriggerVariant) {
//       if (freeProduct1) {
//         await fetch('/cart/change.js', {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json'
//           },
//           body: JSON.stringify({
//             id: freeProduct1.key,
//             quantity: 0
//           })
//         });

//         updated = true;
//       }

//       if (freeProduct2) {
//         await fetch('/cart/change.js', {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json'
//           },
//           body: JSON.stringify({
//             id: freeProduct2.key,
//             quantity: 0
//           })
//         });

//         updated = true;
//       }
//     }
//     if (freeProduct1 && freeProduct1.quantity > 1) {
//       await fetch('/cart/change.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json'
//         },
//         body: JSON.stringify({
//           id: freeProduct1.key,
//           quantity: 1
//         })
//       });

//       updated = true;
//     }

//     if (freeProduct2 && freeProduct2.quantity > 1) {
//       await fetch('/cart/change.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json'
//         },
//         body: JSON.stringify({
//           id: freeProduct2.key,
//           quantity: 1
//         })
//       });

//       updated = true;
//     }
//     if (updated) {
//       const updatedCart = await fetch('/cart.js')
//         .then(response => response.json());

//       document.dispatchEvent(
//         new CustomEvent('cart:updated', {
//           detail: updatedCart
//         })
//       );

//       document.dispatchEvent(
//         new CustomEvent('cart:refresh', {
//           bubbles: true,
//           detail: {
//             cart: updatedCart,
//             open: true
//           }
//         })
//       );

//       disableFreeProductPointer();
//     }

//   } catch (error) {
//     console.error('Cart watcher error:', error);
//   } finally {
//     cartWatcherRunning = false;
//   }
// }

// document.addEventListener('DOMContentLoaded', () => {
//   ensureFreeProducts();
//   disableFreeProductPointer();
// });

// document.addEventListener('change', event => {
//   if (
//     event.target.matches(
//       'input[name="updates[]"], input.cart-quantity'
//     )
//   ) {
//     ensureFreeProducts();
//     disableFreeProductPointer();
//   }
// });

// document.addEventListener(
//   'cart:updated',
//   ensureFreeProducts
// );

// document.addEventListener(
//   'cart:refresh',
//   ensureFreeProducts
// );

// const cartContainer = document.querySelector(
//   'cart-drawer, .cart__wrapper, .cart-items'
// );

// if (cartContainer) {
//   const observer = new MutationObserver(() => {
//     disableFreeProductPointer();
//   });

//   observer.observe(cartContainer, {
//     childList: true,
//     subtree: true
//   });
// }


//Single Offer
const TRIGGER_VARIANTS = [
  51891814007094,
  51678786453814,
  51819741348150
];

const FREE_VARIANT = 51340244025654;

let cartWatcherRunning = false;

async function ensureFreeProduct() {
  if (cartWatcherRunning) return;
  cartWatcherRunning = true;

  try {
    const cart = await fetch('/cart.js').then(r => r.json());

    const hasTrigger = cart.items.some(item =>
      TRIGGER_VARIANTS.includes(item.variant_id)
    );

    const freeItem = cart.items.find(
      item => item.variant_id === FREE_VARIANT
    );

    let updated = false;

    if (hasTrigger && !freeItem) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: FREE_VARIANT, quantity: 1 }]
        })
      });
      updated = true;
    }

    if (!hasTrigger && freeItem) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: freeItem.key,
          quantity: 0
        })
      });
      updated = true;
    }

    if (freeItem && freeItem.quantity > 1) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: freeItem.key,
          quantity: 1
        })
      });
      updated = true;
    }

    if (updated) {
      const updatedCart = await fetch('/cart.js').then(r => r.json());

      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: updatedCart
      }));

      document.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: {
          cart: updatedCart,
          open: true
        }
      }));
    }

  } catch (e) {
    console.error('Cart watcher error:', e);
  } finally {
    cartWatcherRunning = false;
  }
}

document.addEventListener('cart:refresh', ensureFreeProduct);
document.addEventListener('cart:updated', ensureFreeProduct);
document.addEventListener('DOMContentLoaded', ensureFreeProduct);


document.addEventListener('DOMContentLoaded', function () {
  const PREORDER_VARIANT_ID_1 = '51891814007094';
  const PREORDER_VARIANT_ID_2 = '54556956852534';
  const NORMAL_VARIANT_ID = '51678786453814';

  const form = document.getElementById(
    'ProductForm-template--27467468833078__main-product-10036619084086'
  );

  if (!form) return;

  const preorderNote = document.getElementById('preorder-variant-note');

  function updateButtonText() {
    const variantInput = form.querySelector('input[name="id"]');
    const buttonText = form.querySelector('.btn-text');

    if (!variantInput || !buttonText) return;

    const variantId = String(variantInput.value);

    if (
      variantId === PREORDER_VARIANT_ID_1 ||
      variantId === PREORDER_VARIANT_ID_2
    ) {
      buttonText.textContent = 'Buy Now';
    } else if (variantId === NORMAL_VARIANT_ID) {
      buttonText.textContent = 'Buy Now';
    }

    if (preorderNote) {
      preorderNote.hidden =
        variantId !== PREORDER_VARIANT_ID_1 &&
        variantId !== PREORDER_VARIANT_ID_2;
    }
  }

  updateButtonText();

  const variantInput = form.querySelector('input[name="id"]');

  if (variantInput) {
    const observer = new MutationObserver(function () {
      updateButtonText();
    });

    observer.observe(variantInput, {
      attributes: true,
      attributeFilter: ['value']
    });
  }

  const variantPicker = document.getElementById(
    'VariantPicker-template--27467468833078__main-product-10036619084086'
  );

  if (variantPicker) {
    variantPicker.addEventListener('change', function () {
      setTimeout(updateButtonText, 0);
      setTimeout(updateButtonText, 50);
      setTimeout(updateButtonText, 150);
      setTimeout(updateButtonText, 300);
    });
  }
});